<script setup lang="ts">

import GFBSCommandHierarchy
  from '@/components/Sections/Government/Finances/BalanceSheetDetails/CommandHierarchy/GFBSCommandHierarchy.vue'
</script>

<template>
  <div>
    <GFBSCommandHierarchy/>
  </div>
</template>

<style scoped lang="scss">

</style>